import { z } from 'zod';

/** The accept page's form for a new person (`PASSWORD_SIGNUP`). config-backend is the authority on the password. */
export const rudderstackInviteSchema = z
  .object({
    name: z.string().trim().min(1, 'Enter your name').max(100, 'Use at most 100 characters'),
    password: z.string().min(1, 'Enter a password'),
    confirmPassword: z.string().min(1, 'Enter the password again'),
  })
  .superRefine((values, ctx) => {
    if (values.confirmPassword && values.password !== values.confirmPassword) {
      ctx.addIssue({ code: 'custom', path: ['confirmPassword'], message: 'The passwords do not match' });
    }
  });

export type RudderstackInviteValues = z.infer<typeof rudderstackInviteSchema>;
